export default "__VITE_ASSET__D9uzEcTD__"